import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'primeicons/primeicons.css';
import {Provider} from 'react-redux'
import { PrimeReactProvider } from 'primereact/api';
import { store } from './redux/store';
import { LoadingProvider } from './util/LoadingContext';
import './assets/scss/main.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
  <PrimeReactProvider>
    {/* <React.StrictMode> */}
    <LoadingProvider> 
    <App />
    </LoadingProvider>
  {/* </React.StrictMode> */}
  </PrimeReactProvider>
  </Provider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
reportWebVitals();
